export const SPECIAL_FOLDER_ID_ARCHIVED = 'archived';
export const SPECIAL_FOLDER_ID_MY_VIDEOS = 'my-videos';
export const SPECIAL_FOLDER_ID_TEAM_VIDEOS = 'team-videos';
export const SPECIAL_FOLDER_ID_TEAM_ARCHIVED = 'team-archived';
export const SPECIAL_FOLDER_ID_SHARED_VIDEOS = 'shared-videos';

export const ALL_SPECIAL_FOLDER_IDS = [
  SPECIAL_FOLDER_ID_ARCHIVED,
  SPECIAL_FOLDER_ID_MY_VIDEOS,
  SPECIAL_FOLDER_ID_TEAM_VIDEOS,
  SPECIAL_FOLDER_ID_TEAM_ARCHIVED,
  SPECIAL_FOLDER_ID_SHARED_VIDEOS,
];

export const SPECIAL_FOLDER_ID_REGEX = ALL_SPECIAL_FOLDER_IDS.join('|');

export const ARCHIVED_FOLDER_NAME = 'Archived';
export const MY_VIDEOS_FOLDER_NAME = 'Personal Library';
export const TEAM_VIDEOS_FOLDER_NAME = 'Team Library';
export const TEAM_ARCHIVED_FOLDER_NAME = 'Team Archived';
export const SHARED_VIDEOS_FOLDER_NAME = 'Shared Library';

// special folder names for jtbd lookup
export const FOLDER_NAME_HOW_TO_USE_LOOM = 'How To Use Loom';
export const FOLDER_NAME_JTBD = 'jtbd';
export const FOLDER_NAME_OTHER = 'Other';
export const FOLDER_NAME_TOP_5 = 'Top 5';
export const FOLDER_NAME_USE_CASES = 'Use Cases';

export const SPECIAL_FOLDER_ARCHIVED = {
  specialId: SPECIAL_FOLDER_ID_ARCHIVED,
  name: ARCHIVED_FOLDER_NAME,
  description: '',
  favorite: false,
  parentId: null,
  shared: false,
};

export const SPECIAL_FOLDER_MY_VIDEOS = {
  specialId: SPECIAL_FOLDER_ID_MY_VIDEOS,
  name: MY_VIDEOS_FOLDER_NAME,
  description: '',
  favorite: false,
  parentId: null,
  shared: false,
};

export const SPECIAL_FOLDER_SHARED_WITH_ME = {
  specialId: SPECIAL_FOLDER_ID_SHARED_VIDEOS,
  name: SHARED_VIDEOS_FOLDER_NAME,
  description: '',
  favorite: false,
  parentId: null,
  shared: false,
};

export const DEFAULT_FOLDER_NAME = 'Untitled Folder';

// The folders below are not real folders, but it helps to
// treat it as such for how the dashboard behaves. Especially
// for navigation, video filtering, and header breadcrumbs.
export const FOLDER_NAME_FAVORITES = 'Favorites';
export const FOLDER_ID_FAVORITES = 'favorites';

export const SPECIAL_FOLDER_FAVORITES = {
  specialId: FOLDER_ID_FAVORITES,
  name: FOLDER_NAME_FAVORITES,
  description: '',
  favorite: false,
  parentId: null,
  shared: false,
};

export const PAGETYPE_PERSONAL = 'personal';
export const PAGETYPE_TEAM = 'team';
export const PAGETYPE_SHARED = 'shared';
export const PAGETYPE_ARCHIVED = 'archived';
export const PAGETYPE_STARRED = 'starred';
export const PAGETYPE_WATCH_LATER = 'watch-later';
export const PAGETYPE_PUBLIC = 'public';
export const PAGETYPE_SHARED_WITH_ME = 'shared-with-me';
export const PAGETYPE_ACTIVITY_FEED = 'activity-feed';

export const PAGETYPE_NAME_PERSONAL = 'Personal';
export const PAGETYPE_NAME_TEAM = 'Team';
export const PAGETYPE_NAME_SHARED = 'Shared';
export const PAGETYPE_NAME_ARCHIVED = 'Archived';
export const PAGETYPE_NAME_STARRED = 'Starred';
export const PAGETYPE_NAME_WATCH_LATER = 'Watch Later';
export const PAGETYPE_NAME_SHARED_WITH_ME = 'Shared With Me';
export const PAGETYPE_NAME_ACTIVITY_FEED = 'Recent Activity';

export const PAGETYPES = {
  [PAGETYPE_PERSONAL]: PAGETYPE_NAME_PERSONAL,
  [PAGETYPE_TEAM]: PAGETYPE_NAME_TEAM,
  [PAGETYPE_SHARED]: PAGETYPE_NAME_SHARED,
  [PAGETYPE_SHARED_WITH_ME]: PAGETYPE_NAME_SHARED_WITH_ME,
  [PAGETYPE_ARCHIVED]: PAGETYPE_NAME_ARCHIVED,
  [PAGETYPE_STARRED]: PAGETYPE_NAME_STARRED,
  [PAGETYPE_WATCH_LATER]: PAGETYPE_NAME_WATCH_LATER,
  [PAGETYPE_ACTIVITY_FEED]: PAGETYPE_NAME_ACTIVITY_FEED,
};

export const DASHBOARD_ONBOARDING_FRIENDLY_PAGETYPES = new Set([
  PAGETYPE_PERSONAL,
  PAGETYPE_TEAM,
  PAGETYPE_SHARED,
]);

export const NON_LIBRARY_PAGETYPES = new Set([
  PAGETYPE_WATCH_LATER,
  PAGETYPE_SHARED_WITH_ME,
  PAGETYPE_ACTIVITY_FEED,
]);
